'use client';

import type { ReactNode } from 'react';

import { ConfigProvider } from 'antd';

import { DrawerLayout } from '@goodneighbor/admin-ui/server';
import {
  configProviderTheme,
  QueryProvider
} from '@goodneighbor/admin-ui/providers';

import './global.css';

const Config = ({ children }: { children: ReactNode }) => (
  <ConfigProvider theme={configProviderTheme}>
    <QueryProvider>
      {children}
      <DrawerLayout />
    </QueryProvider>
  </ConfigProvider>
);

export { Config };
